import React, { useState } from "react";
import { useAppSelector } from "../../../../../app/hooks";
import { mainColourSelector } from "../../../../chatbotSlice";
import {SliderButtonPosition} from "../../VehicleSliderButton";

export const toRgba = (hex: string, alpha: number) => {
    const m = hex.replace("#", "").match(/.{2}/g);
    if (!m) return `rgba(12,1,38,${alpha})`;
    const [r, g, b] = m.map((x) => parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
};

interface ImageCarouselSlideButtonProps {
    onClick: () => void;
    position: SliderButtonPosition,
    isDisabled?: boolean
}

export const ImageCarouselSlideButton: React.FC<ImageCarouselSlideButtonProps> = ({
                                                                                      onClick,
                                                                                      position,
                                                                                      isDisabled
                                                                                  }) => {
    const mainColour = useAppSelector(mainColourSelector)
    const bgRest  = toRgba(mainColour, 0.65);
    const bgHover = toRgba(mainColour, 0.80);
    const isLeft = position === SliderButtonPosition.BUTTON_LEFT;

    const [hover, setHover] = useState(false);

    return (
        <div
            onClick={onClick}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            className={`flex items-center h-[96px] py-[10px] pr-[2px] pl-[6px] ${isLeft ? "rounded-r-lg" : "rounded-l-lg"} cursor-pointer
                        transition-colors duration-200 select-none
                        ${isDisabled ? 'pointer-events-none animate-fade-out' : 'cursor-pointer hover:shadow-lg'}`}
            style={{ background: hover ? bgHover : bgRest }}
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={`${!isLeft ? "rotate-180" : ""} stroke-white`}
            >
                <path
                    d="M12.5 15.8332L6.66667 9.99984L12.5 4.1665"
                    stroke='white'
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    );
};
